import React from 'react';
import {useSelector} from 'react-redux';
import dateFormat from 'dateformat';

import {commonSelectorFn} from '../../../../../shared/pages/common/redux/selectors';

import * as S from './PersuasionHoverText.styles';
import {IPersuasionText} from '../../../../../shared/pages/SRP/redux/types';
import RoundedCheckbox from '../../../../Icons/RoundedCheckbox';

import HermesIconSelector from '../../../../../shared/components/HermesIconSelector';

import FreeCancelTickIcon from '../../../../Icons/FreeCancelTick';
import DoubleTiclIcon from '../../../../Icons/DoubleTick';

interface IPosition {
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  transform?: string;
}

// can be re-factored to allow more flexible renderItem inside, but requires splicing off
// internal styling and bloating to container level
// currently only 2 scenarios required to be served - List of text, Text block
// if more scenarios are to be pushed, should refactor to renderItem for ContentBlock inside
// something like renderContentBlock()
const PersuasionHoverText = ({
  data,
  actionHandler = () => {},
  direction = 'bottom',
  // hasPersuasionTitlePadding = false,
  defaultIcon = '',
  position,
  persuasionTitleStyles = {},
  type = '',
  hasMainTextIcon = false,
}: {
  data: Array<IPersuasionText>;
  direction?: string;
  actionHandler?: Function;
  // hasPersuasionTitlePadding?: boolean;
  defaultIcon?: string;
  position?: {
    wrapperDiv?: IPosition;
    tip?: IPosition;
  };
  persuasionTitleStyles?: {
    [k: string]: string; // css styles
  };
  type?: string;
  hasMainTextIcon?: boolean;
}) => {
  const colorEmptyInstantiation = {bgc: '', tc: ''};

  const hasSingleItem = data && data.length === 1;

  const isAboveRatePlanPersuasion = type === 'aboveRatePlanPersuasion';
  const isBelowBannerPersuasion = type === 'belowBannerPersuasion';

  const {checkin} = useSelector(commonSelectorFn);

  // const isContentPersuasion2 = type === 'contentPersuasion2';
  return (
    <S.WrapperDiv>
      {data.map((item, index) => {
        if (index > 1) return;

        const {
          ic: labelIconText,
          pt: persuasionTitle,
          ccd: colorCodeDesc = colorEmptyInstantiation,
          htd: hoverTextDescription = {},
          ui: uiType = '',
        } = item;

        const filterData = item?.fd;

        const {
          bgc: persuasionTitleBackgroundColor = '',
          tc: persuasionTitleTextColor = '',
          ig: isGradient = false,
        } = colorCodeDesc;

        const {
          ht: hoverTextArr = [],
          ft: hoverFilterText = '',
          hec: hoverTitleColor = colorEmptyInstantiation,
          h: hoverTextTitle = '',
          ic: iconText = '',
          hoc: hoverColor = colorEmptyInstantiation,
        } = hoverTextDescription;

        const {tc: hoverTitleTextColor = '', bgc: hoverTitleBackgroundColor = ''} = hoverTitleColor;

        const {tc: hoverTextColor = '', bgc: hoverBackgroundColor = ''} = hoverColor;

        const hasHover = item?.htd;

        const mainTextIconName =
          isAboveRatePlanPersuasion && index === 0 ? 'tVoyagerPer' : labelIconText || iconText;

        const isGpt = uiType && uiType === 'gpt';

        if (isGpt) return null;

        return (
          <S.HoverTargetWrapperDiv
            key={persuasionTitle + index}
            hasMultiple={!hasSingleItem}
            type={type}
          >
            {(hasMainTextIcon && mainTextIconName && index === 0 && (
              <S.MainTextIconWrapperSpan type={type}>
                <HermesIconSelector
                  name={mainTextIconName}
                  styleProps={{height: '1.6rem', width: '1.6rem', fill: persuasionTitleTextColor}}
                />
              </S.MainTextIconWrapperSpan>
            )) ||
              null}

            <S.TextWrapperSpan
              {...persuasionTitleStyles}
              hasHover={hasHover}
              color={persuasionTitleTextColor}
              bgColor={persuasionTitleBackgroundColor}
              isGradient={isGradient}
              type={type}
              hasBgColor={
                persuasionTitleBackgroundColor &&
                !(['#ffffff', 'white'].indexOf(persuasionTitleBackgroundColor) > -1)
              }
              hasSingleItem={hasSingleItem}
              onClick={type === 'customLocation' ? actionHandler : () => {}}
            >
              {isBelowBannerPersuasion ? <>
                <span>Free Cancellation</span>
                <DoubleTiclIcon marginleft="0.5rem"/>
              </> : <span>{persuasionTitle}</span>}
            </S.TextWrapperSpan>

            {(isBelowBannerPersuasion && hoverTextDescription && Object.keys(hoverTextDescription).length > 0 && (
              <S.HiddenDropdownWrapperDiv
                top="1.5rem"
                bottom={position?.wrapperDiv?.bottom}
                left={position?.wrapperDiv?.left}
                right={position?.wrapperDiv?.right}
                direction={direction}
                width="36.5rem"
              >
                <S.TopDiv>
                  <S.TextBlockDropDownWrapper
                    color={hoverTextColor}
                    bgColor="#fff"
                    height="15rem"
                  >
                    <S.FreeCancelTipTopBlock>
                      <S.CancelImg>
                        <FreeCancelTickIcon />
                      </S.CancelImg>
                      <S.CancelInfoTextWrap>
                        <S.InfoFadedText>Stay Flexible</S.InfoFadedText>
                        <S.InfoMainBoldText>Free Cancellation</S.InfoMainBoldText>
                      </S.CancelInfoTextWrap>
                      
                    </S.FreeCancelTipTopBlock>
                    <S.CancelSliderWrap>
                      {persuasionTitle.toLowerCase() === 'checkin' ? <S.SliderInnerWrap width="100%" full>
                        <S.FreeCancelMainText>Free Cancellation till <span>{persuasionTitle}</span></S.FreeCancelMainText>
                        <S.SliderOtherCircle />
                      </S.SliderInnerWrap> : <S.SliderInnerWrap width="80%">
                        <S.FreeCancelMainText>Free Cancellation till <span>{persuasionTitle}</span></S.FreeCancelMainText>
                        <S.SliderOtherCircle />
                        <S.FreeDateText>{persuasionTitle}</S.FreeDateText>
                      </S.SliderInnerWrap>}

                      <S.SliderFirstCircle />

                      <S.NowText>Now</S.NowText>
                      <S.finalCheckDate>{dateFormat(checkin.date, 'dd mmm')} <br/><span>Check-in</span></S.finalCheckDate>
                      
                    </S.CancelSliderWrap>
                  </S.TextBlockDropDownWrapper>
                  <S.TipPositioning
                    top={position?.tip?.top}
                    bottom={position?.tip?.bottom}
                    left={position?.tip?.left}
                    right={position?.tip?.right}
                    transform={position?.tip?.transform}
                    bgColor="#fff"
                    direction={direction}
                  />
                </S.TopDiv>
              </S.HiddenDropdownWrapperDiv>
            )) ||
              null}

            {(!isBelowBannerPersuasion && hoverTextDescription &&
                Object.keys(hoverTextDescription).length > 0 && (
                  <S.HiddenDropdownWrapperDiv
                    top={position?.wrapperDiv?.top}
                    bottom={position?.wrapperDiv?.bottom}
                    left={position?.wrapperDiv?.left}
                    right={position?.wrapperDiv?.right}
                    direction={direction}
                    className="persuasion-hover"
                    width="20rem"
                  >
                    <S.TopDiv>
                      <S.TextBlockDropDownWrapper
                        color={hoverTextColor}
                        bgColor={hoverBackgroundColor}
                      >

                        <S.TextBlockDDHeading
                          color={hoverTitleTextColor}
                          bgColor={hoverTitleBackgroundColor}
                        >
                          <S.TextBlockDDHeadingSpan
                            color={hoverTitleTextColor}
                            bgColor={hoverTitleBackgroundColor}
                            onClick={type === 'customLocation' ? actionHandler : () => {}}
                          >
                            <S.PersuasionHoverTitleSpan type={type}>
                              {hoverTextTitle}
                            </S.PersuasionHoverTitleSpan>
                          </S.TextBlockDDHeadingSpan>
                        </S.TextBlockDDHeading>

                        {(hoverTextArr.length > 1 &&
                          hoverTextArr.map((item, index) => (
                            <S.IconWrapperDiv key={index + item}>
                              <S.RoundBoxWrap>
                                <RoundedCheckbox fill={persuasionTitleTextColor} />
                              </S.RoundBoxWrap>
                              <S.TextWrapper>{item}</S.TextWrapper>
                            </S.IconWrapperDiv>
                          ))) || (
                          <S.TextBlockDDFilterText>
                            {hoverTextArr.map(item => item)}
                          </S.TextBlockDDFilterText>
                        )}
                      </S.TextBlockDropDownWrapper>
                      <S.TipPositioning
                        top={position?.tip?.top}
                        bottom={position?.tip?.bottom}
                        left={position?.tip?.left}
                        right={position?.tip?.right}
                        transform={position?.tip?.transform}
                        bgColor={hoverBackgroundColor}
                        direction={direction}
                      />
                    </S.TopDiv>
                  </S.HiddenDropdownWrapperDiv>
                )) ||
                null}
          </S.HoverTargetWrapperDiv>
        );
      })}
    </S.WrapperDiv>
  );
};

export default PersuasionHoverText;
